module.exports = __webpack_public_path__ + "static/media/box.96e85477.svg";